<template>
    <div class="checkbox-item" :class="loading ? 'loading-state' : ''">
        <input v-show="!loading" :id="'item-'+item.id" v-model="item.checked" type="checkbox" @click="handleClick"/>
        <label :for="'item-'+item.id">{{item.text}}</label>
        <icon-spinner class="loader" v-if="loading"></icon-spinner>
    </div>
</template>

<script>
    import IconSpinner from "../common/icons/IconSpinner";
    import {mapActions} from "vuex";


    export default {
        name: 'check-list-item',
        components: {
            IconSpinner
        },
        props: {
            item: Object,
        },
        data () {
            return {
                loading: false
            }
        },
        methods: {
            ...mapActions('checkLists', [
                'changeListItem'
            ]),
            handleClick() {
                this.loading = true;
                this.changeListItem().then(() => {
                    this.loading = false;
                    this.$emit('itemClick');
                });

            },
        },
    }
</script>

<style scoped>

</style>
